namespace $ {

	export type $shm_ba_file_store_record = {
		key: string
		app_id: string
		name: string
		size: number
		updated: number
	}

	export class $shm_ba_file_store extends $mol_object2 {

		static prefix() {
			return 'hitalama-ba-csv:'
		}

		static wordstat_prefix() {
			return 'hitalama_wordstat_'
		}

		static app_prefix( app_id: string ) {
			return `${ this.prefix() }${ app_id }:`
		}

		static key_parse( key: string ) {
			if( key.startsWith( this.wordstat_prefix() ) && key.endsWith( '.duckdb' ) ) {
				return {
					key,
					app_id: 'wordstat',
					name: key,
				}
			}

			if( !key.startsWith( this.prefix() ) ) return null

			const tail = key.slice( this.prefix().length )
			const separator = tail.indexOf( ':' )
			if( separator < 0 ) return null

			return {
				key,
				app_id: tail.slice( 0, separator ),
				name: tail.slice( separator + 1 ),
			}
		}

		@ $mol_mem_key
		static version( prefix: string, next?: number ) {
			return next ?? 0
		}

		static changed( prefix: string ) {
			this.version( this.prefix(), this.version( this.prefix() ) + 1 )
			return this.version( prefix, this.version( prefix ) + 1 )
		}

		@ $mol_mem
		static files() {
			this.version( this.prefix() )
			return $mol_wire_sync( this ).files_async()
		}

		static async files_async() {
			const storage = navigator.storage
			if( !storage?.getDirectory ) return [] as readonly $shm_ba_file_store_record[]

			const root = await storage.getDirectory()
			const files = [] as $shm_ba_file_store_record[]

			for await( const [ name, handle ] of ( root as any ).entries() ) {
				const parsed = this.key_parse( String( name ) )
				if( !parsed ) continue
				if( handle.kind !== 'file' ) continue

				const file = await handle.getFile()
				files.push({
					... parsed,
					size: file.size,
					updated: file.lastModified,
				})
			}

			return files.sort( ( left, right )=> {
				if( left.app_id !== right.app_id ) return left.app_id.localeCompare( right.app_id )
				return left.name.localeCompare( right.name )
			} )
		}

		static delete( key: string ) {
			return $mol_wire_sync( this ).delete_async( key )
		}

		static async delete_async( key: string ) {
			const storage = navigator.storage
			if( !storage?.getDirectory ) return

			const root = await storage.getDirectory()
			await root.removeEntry( key )

			const parsed = this.key_parse( key )
			this.changed( parsed ? this.app_prefix( parsed.app_id ) : this.prefix() )
		}

		static delete_all() {
			return $mol_wire_sync( this ).delete_all_async()
		}

		static async delete_all_async() {
			const storage = navigator.storage
			if( !storage?.getDirectory ) return

			const root = await storage.getDirectory()
			const app_ids = new Set< string >()
			for await( const [ name, handle ] of ( root as any ).entries() ) {
				if( handle.kind !== 'file' ) continue
				const parsed = this.key_parse( String( name ) )
				if( !parsed ) continue
				await root.removeEntry( String( name ) )
				app_ids.add( parsed.app_id )
			}

			this.changed( this.prefix() )
			for( const app_id of app_ids ) this.changed( this.app_prefix( app_id ) )
		}

	}

}
